


































import { Component, Vue } from 'vue-property-decorator';
import * as firebase from "firebase/app";
import "firebase/auth";

@Component
export default class RecoverPassword extends Vue {
  private loading = false;
  private showMessage = false;
  private message = '';
  private user: { email: string} = {
    email: ''
  };

  recover() {
    this.loading = true;
    firebase
      .auth()
      .sendPasswordResetEmail(this.user.email)
      .then(() => {
        this.loading = false;
        this.showMessage = true;
        this.message = 'Listo! Revisa tu correo para recuperar tu cuenta.';
        setTimeout(()=>{
          this.$router.push('/')
        }, 5000)
      })
      .catch((error) => {
        this.showMessage = true;
        this.loading = false;
        this.message = 'Ha ocurrido un error. intenta nuevamente.';
        if (error.code == 'auth/user-not-found') this.message = 'Correo no encontrado';
        if (error.code == 'auth/invalid-email') this.message = 'El correo ingresado no es válido';
      });
  }
}
